import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/auth/auth.store';
import { useUIStore } from '../../stores/ui/ui.store';

interface RenewTokenDialogProps {
  open: boolean;
  refreshToken: string;
}

const RenewTokenDialog = (props: RenewTokenDialogProps) => {
  const { loading } = useUIStore((state) => state);
  const { logout, renewTimeFrame, renewToken, updateTimeFrame } = useAuthStore((state) => state);
  const [logoutCountdown, setLogoutCountdown] = useState(renewTimeFrame);

  useEffect(() => {
    if (logoutCountdown <= 0) return;

    const timeout = setTimeout(() => {
      const remainingTimeFrame = renewTimeFrame - 1000;
      updateTimeFrame(remainingTimeFrame);
      setLogoutCountdown(remainingTimeFrame);
    }, 1000);

    return () => clearTimeout(timeout);
  });

  const logoutHandler = () => logout();
  const renewHandler = () => renewToken(props.refreshToken);

  if (logoutCountdown <= 0) {
    /* TODO: Use auth store */
    localStorage.removeItem('auth');
    window.location.replace('/login');
  }

  const secondsToLogout = logoutCountdown / 1000;

  return (
    <Dialog open={props.open}>
      <DialogTitle>Su sesión está por terminar</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Presione RENOVAR para mantener su sesión abierta o presione CERRRAR para ser redirigido a
          la página de inicio de sesión.
        </Typography>
        <Typography gutterBottom>
          Tienes {secondsToLogout} segundo(s) para renovar tu sesión.
        </Typography>
        {loading && <LinearProgress />}
      </DialogContent>
      <DialogActions>
        <Button onClick={logoutHandler} disabled={loading}>
          Cerrar
        </Button>
        <Button
          onClick={renewHandler}
          disabled={loading}
          color="secondary"
          variant="contained"
          disableElevation
          autoFocus
        >
          Renovar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenewTokenDialog;
